import React from "react";
import { colors } from "../../../../../../themes/Colors";
import SearchBar from "../../../../../common-components/search-bar/SearchBar";
import {
  BaseButtons,
  BaseButtonsIcon,
  TextInputField,
} from "../../../../../common-components";

const ActionBar = ({
  title,
  onAddClick,
  value,
  onChange,
  onSearchClick,
  onClearClick,
}) => {
  return (
    <div
      style={{
        width: "100%",

        height: 60,
        display: "flex",
        alignItems: "center",
        // backgroundColor: colors.white,
      }}
    >
      <div style={{ fontSize: 18, fontWeight: "bold", marginLeft: 20 }}>
        {title ? title : "DUMMY TITLE"}
      </div>
      <div style={{ flex: 1 }} />
      <div style={{ display: "flex", marginRight: 10, alignItems: "center" }}>
        <div style={{ marginBottom: 5, marginRight: 20 }}>
          <TextInputField
            value={value}
            onChange={onChange}
            mini={true}
            marginTop={-1}
            height={20}
            placeholder={"Type here to search"}
          />
        </div>
        <BaseButtons
          label={"CLEAR"}
          onClick={onClearClick}
          borderRadius={8}
          backgroundColor={colors.orangeDark}
        />
        <div style={{ minWidth: 10 }} />
        <BaseButtons
          label={"SEARCH"}
          onClick={onSearchClick}
          borderRadius={8}
          backgroundColor={colors.primaryBlue}
        />

        {/* <BaseButtonsIcon
          height={40}
          width={40}
          borderRadius={8}
          backgroundColor={colors.secondaryDarkBlue}
          icon={require("../../../../../../images/material-icon/whiteSettings.png")}
          iconHeight={30}
          iconWidth={30}
        /> */}
        <div style={{ minWidth: 20 }} />
        {/* <BaseButtonsIcon
          height={40}
          width={40}
          backgroundColor={colors.secondaryDarkBlue}
          borderRadius={8}
          icon={require("../../../../../../images/material-icon/whiteSettings.png")}
          iconHeight={30}
          iconWidth={30}
        /> */}
        <BaseButtons
          label={"ADD AGENT"}
          backgroundColor={colors.primaryBlue}
          borderRadius={8}
          width={120}
          onClick={onAddClick}
        />
      </div>
    </div>
  );
};

export default ActionBar;
